import Component from '../component';
import Google from '../../helpers/google';

export default class PopinLogin extends Component {
	constructor(...args) {
		super(...args);

        this._action = 'candiapro_login';
        this._is_process = false;

		this._duration = 0.5;
		this._initDom();
	}

	_initDom() {
		this.dom.callPopin = document.body.querySelectorAll('.js-call-login');
		this.dom.closePopin = this.dom.component.querySelector('.js-close-login');
		this.dom.inputs = this.dom.component.querySelectorAll('input');
		
		this.dom.responseError = this.dom.component.querySelector('.response-error');
		this.dom.btnLogin = this.dom.component.querySelector('.btn-login');
	}

	bind() {
		// if( this.dom.callPopin ) {
		// 	for( var i = 0, j = this.dom.callPopin.length; i < j; i++ ) {
        //         this.dom.callPopin[i].addEventListener('click', this._openPopin.bind(this));
		// 	}
		// }
        // Delegate event to trigger call login on dynamic dom
		delegate(document.body, '.js-call-login', 'click', this._openPopin.bind(this));

		this.dom.closePopin.addEventListener('click', this._closePopin.bind(this));
		this.dom.btnLogin.addEventListener('click', this._sendLogin.bind(this));
	}

	_sendLogin() {
		if( this._is_process == false ) {

			this._is_process = true;
            let errorUser = 0;
            let objUser = {};
			this._cleanInputs();

			for (let i = 0; i < this.dom.inputs.length; i++) {
				const el = this.dom.inputs[i];
				const key = el.getAttribute('data-name');
				const value = el.value;

				if (el.classList.contains('email')) {
					if (this._checkEmail() == false) {
						el.classList.add('error');
						errorUser++;
					}
				}

				objUser[key] = value;
			}

			if (errorUser != 0) {
                this._is_process = false;
			} else {
				this._send(objUser);
			}
		}
	}

	_send(obj) {
		// Format data
        var data = new FormData();
        data.append( 'email', obj.email );
        data.append( 'password', obj.password );

        document.body.classList.add('loading');
        this.dom.btnLogin.classList.add('loading');
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/ajax.php?action=' + this._action, true);
        xhr.onreadystatechange = function () {
            console.log(xhr);
            if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                this._response( (JSON.parse(xhr.response) ));
            }
        }.bind(this);
        xhr.send(data);

		// this.dom.responseError.innerHTML = xhr.error.msg;
	}


    _response( response ) {

        if( response.success == true ) {
        	window.location.reload(true);
            // window.location.href = response.data.redirect;
        } else {
            this._is_process = false;
            document.body.classList.remove('loading');
            this.dom.btnLogin.classList.remove('loading');

            /** Bad email **/
            if( response.data.error == 'invalid_email' )
            {
                this.dom.responseError.innerHTML = 'L\'adresse email n\'existe pas.';
            }

            /** Bad Password **/
            if( response.data.error == 'incorrect_password' )
            {
                this.dom.btnLogin.classList.remove('loading');

                this.dom.responseError.innerHTML = 'Mot de passe incorrect.';
            }
        }

    }

	_openPopin() {
		Google.pushCustomTracker('Login', document.URL);
		TweenLite.to(this.dom.component, this._duration, {
			autoAlpha: 1,
			ease: Power3.easeOut,
			onComplete: () => {
                document.body.classList.add('no-scroll');
			}
		});
	}

	_closePopin() {
        document.body.classList.remove('no-scroll');
		TweenLite.to(this.dom.component, this._duration, {
			autoAlpha: 0,
			ease: Power3.easeOut
		});
	}

	// Helpers
	_cleanInputs() {
		for (let i = 0; i < this.dom.inputs.length; i++) {
			this.dom.inputs[i].classList.remove('error');
		}
	}

	_checkEmail() {
		let regExp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		if (regExp.test(this.dom.component.querySelector('[data-name="email"]').value)){
			return true;
		} else {
			return false;
		}
	}



	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/popin-login/popin-login.js